import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import type { FC } from "react";
import { useUtagDataScript } from "./hooks/useUtagDataScript";
import { useIntegrationScript, useIntegrationScriptQA } from "./hooks/useIntegrationScript";
import { useUtag } from "./hooks/useUtag";
import { isAnalyticsHidden, isAnalyticsQAHidden } from "./configuration";

const isWaitingLinkSymbol = Symbol("isWaitingLink");

export const TealiumAnalytics: FC = () => {
  const integrationScript = useIntegrationScript();
  const integrationScriptQA = useIntegrationScriptQA();
  const utag_data = useUtagDataScript();
  const utag = useUtag();

  useEffect(() => {
    if (utag && utag_data && !isAnalyticsHidden) {
      if (utag[isWaitingLinkSymbol] !== true) {
        utag.view(utag_data);
        utag[isWaitingLinkSymbol] = true;
      } else {
        utag.link(utag_data);
      }
    }
  }, [utag_data, utag]);

  if (!isAnalyticsHidden) {
    return (
      <Helmet>
        <script type="text/javascript">{integrationScript}</script>
      </Helmet>
    );
  } else if (!isAnalyticsQAHidden) {
    return (
      <Helmet>
        <script type="text/javascript">{integrationScriptQA}</script>
      </Helmet>
    );
  } else {
    return null;
  }
};
